__turbopack_context__.v({
  "icon": "ourCommitment-module-scss-module__Qn9Lsq__icon",
  "item": "ourCommitment-module-scss-module__Qn9Lsq__item",
  "list": "ourCommitment-module-scss-module__Qn9Lsq__list",
});
